import { createSlice } from "@reduxjs/toolkit";
export const adminNotificationSlice = createSlice({
  name: "adminNotificationSlice",
  initialState: {
    adminNotificationCount: 0,
    notificationFilter: {},
  },
  reducers: {
    setAdminNotificationCount: (state, action) => {
      return { ...state, adminNotificationCount: action.payload };
    },
    setNotificationFilter: (state, action) => {
      return { ...state, notificationFilter: action.payload };
    },
    resetDealerNotification: (state) => {
      return { ...state, notificationFilter: {} };
    },
  },
});

export const {
  setAdminNotificationCount,
  setNotificationFilter,
  resetDealerNotification,
} = adminNotificationSlice.actions;

export default adminNotificationSlice.reducer;
